import { render, staticRenderFns } from "./ErrModule.vue?vue&type=template&id=6c64c1d4&scoped=true&"
import script from "./ErrModule.vue?vue&type=script&lang=js&"
export * from "./ErrModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c64c1d4",
  null
  
)

export default component.exports